module.exports = __webpack_public_path__ + "static/media/gokrisp-header.31b61e7e.png";